import clsx from 'clsx';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const LoadingModal = _ref => {
  let {
    title // hasProgress,
    // progressValue

  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: styles.overlay,
    children: /*#__PURE__*/_jsx("div", {
      className: styles.container,
      children: /*#__PURE__*/_jsx(Loader, {
        title: title
      })
    })
  });
};

export const Loader = _ref2 => {
  let {
    title = 'Loading',
    className
  } = _ref2;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: clsx(styles.canvas, className || ''),
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.canvasLoader,
        children: /*#__PURE__*/_jsx("svg", {
          viewBox: "0 0 80 80",
          children: /*#__PURE__*/_jsx("circle", {
            id: "test",
            cx: "40",
            cy: "40",
            r: "32"
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: clsx(styles.canvasLoader, styles['canvasLoader--triangle']),
        children: /*#__PURE__*/_jsx("svg", {
          viewBox: "0 0 86 80",
          children: /*#__PURE__*/_jsx("polygon", {
            points: "43 8 79 72 7 72"
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.canvasLoader,
        children: /*#__PURE__*/_jsx("svg", {
          viewBox: "0 0 80 80",
          children: /*#__PURE__*/_jsx("rect", {
            x: "8",
            y: "8",
            width: "64",
            height: "64"
          })
        })
      })]
    }), title && /*#__PURE__*/_jsx("h3", {
      className: styles.heading,
      children: title
    })]
  });
};
export default LoadingModal;